/**
 * Custom High-Performance Inertial Touch Swiper Engine
 * Fixes loading delays by using continuous loop tracking buffers
 */
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.solar-testimonials-wrapper');
  if (!wrapper) return;

  const slider = wrapper.querySelector('.solar-testimonials-slider');
  const track = wrapper.querySelector('.solar-testimonials-track');
  let originalCards = Array.from(wrapper.querySelectorAll('.solar-testimonial-card-container'));
  const prevBtn = wrapper.querySelector('.prev-btn');
  const nextBtn = wrapper.querySelector('.next-btn');

  if (!track || originalCards.length === 0) return;

  // Build a secure chain of duplicate blocks to guarantee instant looping resets
  for (let i = 0; i < 3; i++) {
    originalCards.forEach(card => {
      const clone = card.cloneNode(true);
      track.appendChild(clone);
    });
  }
  
  // Animation Translation States
  let currentX = 0;
  let isDragging = false;
  let startX = 0;
  let dragX = 0;
  let animationFrameId = null;

  // Read Customizer Parameters
  const autoplayDesktop = wrapper.getAttribute('data-autoplay-desktop') === 'true';
  const speedSettingDesktop = parseFloat(wrapper.getAttribute('data-autoplay-speed-desktop')) || 2;
  const autoplayMobile = wrapper.getAttribute('data-autoplay-mobile') === 'true';
  const speedSettingMobile = parseFloat(wrapper.getAttribute('data-autoplay-speed-mobile')) || 2;

  // Calculate pixel adjustments per animation tick frame request
  function getScrollSpeed() {
    const rawSpeed = window.innerWidth <= 768 ? speedSettingMobile : speedSettingDesktop;
    return rawSpeed * 0.45; 
  }

  function isAutoplayEnabled() {
    return window.innerWidth <= 768 ? autoplayMobile : autoplayDesktop;
  }

  function getCardWidth() {
    return originalCards[0].offsetWidth;
  }

  function getGap() {
    return 32;
  }

  function getTotalBlockWidth() {
    return originalCards.length * (getCardWidth() + getGap());
  }

  // High-Frequency Performance Loop Engine
  function renderLoop() {
    if (!isDragging && isAutoplayEnabled()) {
      currentX -= getScrollSpeed();
      
      // Instantly resets without delay when matching parent boundaries
      const resetBoundary = getTotalBlockWidth();
      if (Math.abs(currentX) >= resetBoundary) {
        currentX += resetBoundary; 
      }
      track.style.transform = `translateX(${currentX}px)`;
    }
    animationFrameId = requestAnimationFrame(renderLoop);
  }

  // Touch and Drag Coordinators 
  function handleDragStart(e) {
    isDragging = true;
    startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    dragX = currentX;
    track.style.transition = 'none';
  }

  function handleDragMove(e) {
    if (!isDragging) return;
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - startX;
    currentX = dragX + deltaX;

    // Reset loop constraints instantly mid-drag if thresholds are exceeded
    const resetBoundary = getTotalBlockWidth();
    if (currentX > 0) {
      currentX -= resetBoundary;
    } else if (Math.abs(currentX) >= resetBoundary * 2) {
      currentX += resetBoundary;
    }

    track.style.transform = `translateX(${currentX}px)`;
  }

  function handleDragEnd() {
    isDragging = false;
  }

  // Button Click Smooth Target Push Animation
  function buttonNavigate(direction) {
    if (isDragging) return;
    isDragging = true; // Temporary lock while sliding
    
    const step = getCardWidth() + getGap();
    let targetX = currentX + (direction * step);

    let startTime = null;
    const startXVal = currentX;
    const duration = 450; // Fluid 450ms translation window

    function smoothStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 4); // Premium quartic ease out curve
      
      currentX = startXVal + (targetX - startXVal) * ease;
      track.style.transform = `translateX(${currentX}px)`;

      if (progress < 1) {
        requestAnimationFrame(smoothStep);
      } else {
        isDragging = false; // Re-enable auto-scroll loop
      }
    }
    requestAnimationFrame(smoothStep);
  }

  // Global Interactive Events Registration
  if (nextBtn) nextBtn.addEventListener('click', () => buttonNavigate(-1));
  if (prevBtn) prevBtn.addEventListener('click', () => buttonNavigate(1));

  // Desktop Mouse Events Drag Bindings
  slider.addEventListener('mousedown', handleDragStart);
  slider.addEventListener('mousemove', handleDragMove);
  window.addEventListener('mouseup', handleDragEnd);

  // Mobile Touch Events Swiper Bindings
  slider.addEventListener('touchstart', handleDragStart, { passive: true });
  slider.addEventListener('touchmove', handleDragMove, { passive: true });
  window.addEventListener('touchend', handleDragEnd);

  // Kickstart processing loops
  animationFrameId = requestAnimationFrame(renderLoop);
});